import React from 'react';
import { min, uniq } from 'lodash';
import { useSelector } from 'react-redux';

import Image from '../../components/Image/Image';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import Currency from '../../../helpers/currency';
import { speedIndexToSpeed } from '../../../helpers/tiresHelper';
import TireEnergyLabelLinks from './TireEnergyLabelLinks';
import { InternalLink } from '../../components/form-elements/Link';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';

export default function TireListRow({ tire }) {
    const markenStandort = useSelector(markenStandortSelector);
    if (!tire?.selectedBezugsquelle?.artNummer || !tire.energyLabelUrl) {
        return null;
    }

    const to = tire.href;
    const pickupPrice = tire.selectedBezugsquelle.vk_preis;
    const onlinePrice = tire.selectedBezugsquelle.onlineVK;
    const validPrices = [pickupPrice, onlinePrice].filter(price => price > 0);
    const shownPrice = min(validPrices);
    const showStartingAt = uniq(validPrices).length > 1;

    return (
        <div>
            <div className="uk-grid uk-grid-small" data-uk-grid="">
                <div className="uk-width-1-4@m uk-width-1-1">
                    <InternalLink to={to} modifier="reset">
                        <div className="uk-flex uk-flex-center uk-position-relative">
                            <div>
                                <div className="uk-flex uk-flex-middle" style={{ height: 235 }}>
                                    <Image style={{ maxHeight: 235 }} src={tire.imagelink} alt={tire.neutralKey} resizeHeight={235} />
                                </div>
                            </div>
                        </div>
                    </InternalLink>
                </div>
                <div className="uk-width-expand">
                    <InternalLink to={to} modifier="reset">
                        <h2>{tire.hersteller}</h2>
                        <div>{tire.warengruppe}</div>
                        <div>{tire.bezeichnung}</div>
                        <div>
                            Geschwindigkeitsindex: {tire.geschwindigkeitsindex} bis {speedIndexToSpeed[tire.geschwindigkeitsindex]} km/h
                        </div>
                    </InternalLink>
                    <div className="uk-margin-small ">
                        <TireInformationModal tire={tire} />
                    </div>
                </div>
                <div className="uk-width-1-4@m uk-width-1-1 uk-text-center">
                    <InternalLink to={to} modifier="reset">
                        <div className="uk-margin-auto-top uk-text-center">
                            <h3 className="uk-margin-remove-top">
                                {showStartingAt && !markenStandort.isTechno &&  <span>ab </span>}
                                <Currency quantity={shownPrice} />
                                <span className="uk-text-light uk-text-small"> /Stück</span>
                            </h3>
                        </div>
                    </InternalLink>
                    <div data-uk-grid="" className="uk-grid-small uk-child-width-1-1">
                        <div>
                            <InternalLink to={to} fullWidth modifier="secondary">
                                ZUM PRODUKT
                            </InternalLink>
                        </div>
                        <TireEnergyLabelLinks tire={tire} />
                    </div>
                </div>
            </div>
            <hr />
        </div>
    );
}
